import React from 'react'

const SvgSneakerFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M15.886 10.948l1.094.366-.77 1.336a1 1 0 001.731 1l.975-1.688 1.107.37a2.894 2.894 0 01-.918 5.64h-7.648l-2.52-2.947a5 5 0 00-3.8-1.75H1.939v-3.258a1 1 0 011-1h.588c.332 0 .637.17.853.422A4.49 4.49 0 007.79 11a4.483 4.483 0 002.966-1.116c.231-.203.527-.326.833-.302l.276.021 2.086.698-.816 1.415a1 1 0 001.732 1l1.02-1.768z' />
    <path d='M1.94 15.275v.696a2 2 0 002 2h4.885l-1.408-1.646a3 3 0 00-2.28-1.05H1.939z' />
  </svg>
)

export default SvgSneakerFilled
